(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/fractiongames/assets/javascript/prescript.js') >= 0) return;  svs.modules.push('/modules/fractiongames/assets/javascript/prescript.js');
"use strict";


svs.fractiongames = svs.fractiongames || {};
svs.fractiongames.components = svs.fractiongames.components || {};
svs.fractiongames.pages = svs.fractiongames.pages || {};
svs.fractiongames.pages = svs.fractiongames.pages || {};
svs.fractiongames.products = svs.fractiongames.products || {};
svs.fractiongames.products.components = svs.fractiongames.products.components || {};
svs.fractiongames.contexts = svs.fractiongames.contexts || {};
svs.fractiongames.contexts.products = svs.fractiongames.contexts.products || {};

 })(window);